export const environment = {
    backendURL: 'https://shop.acventis.de/api/',
    // ownBackendURL: 'http://localhost:8080/'
    ownBackendURL: process.env.NODE_ENV === 'production' ? 'https://config-backend.acventis.one/' :'http://localhost:8080/',
    newBackendURL: 'https://acventis.com/api/',
    // backendURL: 'http://localhost:8010/proxy/api/'
}
